import { Box } from '@cowsquare/design';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { useAdsQuery, usePagesBindingUrl } from '../../../../utils/hooks';
import { Advertisements } from '../../../Advertisements';
import { MedicalCardListLoading } from '../../../Loading';
import MedicalCardList from '../../../MedicalCardList';
import { Section } from '../../../Section';
import { Title } from '../../../Title';

const PAGE_SIZE = 21;

const GET_EVENT_ORGANIZERS = gql`
  query getEventOrganizers($limit: Int, $offset: Int) {
    total: hkdutest_event_organizers_aggregate {
      aggregate {
        count
      }
    }

    list: hkdutest_event_organizers(limit: $limit, order_by: { name: desc }, offset: $offset) {
      id
      name
      address
      phone
      cover: logo {
        link
      }
    }
  }
`;

const List = ({ location, uri }) => {
  const [page, onPageChange] = usePagesBindingUrl(location, uri);
  const { ads } = useAdsQuery(uri);
  return (
    <Query
      query={GET_EVENT_ORGANIZERS}
      variables={{
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      }}
    >
      {({ data, loading }) => {
        const list = R.propOr([], 'list', data);
        const total = R.pathOr(0, ['total', 'aggregate', 'count'], data);

        return (
          <Section>
            <Helmet>
              <title>Event Organizers - HKDU CME</title>
            </Helmet>
            <Advertisements ads={ads} />
            <Box px={[5, 0]} pt={8}>
              <Title mb={6}>Event Organizers</Title>
              {R.and(R.isEmpty(list), loading) && <MedicalCardListLoading hasCover />}
              <MedicalCardList
                height="364px"
                cardData={list}
                defaultCover={defaultCover}
                total={total}
                uri={uri}
                page={page}
                onPageChange={onPageChange}
              />
            </Box>
          </Section>
        );
      }}
    </Query>
  );
};

export default List;
